import '@ap/ui/styles.css'
import '@ap/ui/brand.css'
import './alice-admin.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { LocaleProvider } from '@ap/i18n'
import { ToastProvider } from '@ap/ui'
import { App } from './App.tsx'
import { AdminSessionProvider } from './session.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LocaleProvider>
      <ToastProvider>
        <AdminSessionProvider>
          <App />
        </AdminSessionProvider>
      </ToastProvider>
    </LocaleProvider>
  </StrictMode>,
)
